import { useEffect } from "react";

import UILoader from "@/components/ui/Loader";
import { getGalleryPricingUrl } from "@/utils/getGalleryPricingUrl";

const GalleryPricingRedirect = () => {
  useEffect(() => {
    // The token exchange is async — drop the result if the user left meanwhile.
    let cancelled = false;

    getGalleryPricingUrl().then((url) => {
      if (!cancelled) window.location.replace(url);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return <UILoader />;
};

export default GalleryPricingRedirect;
